import { createElement, type ReactNode } from "react"
import cc from "classnames"

interface CardProps {
  children: ReactNode
  as?: string
  spacing?: CardSpacing
  class_name?: string
  "aria-selected"?: boolean
  "data-cy"?: string
}

type CardSpacing = "small" | "large"

const Card = (props: CardProps): JSX.Element => {
  return createElement(
    props.as ?? "div",
    {
      className: cc("border border-neutral-200 rounded-16 p-16", {
        [String(props.class_name)]: props.class_name,
      }),
      "aria-selected": props["aria-selected"],
      "data-cy": props["data-cy"],
    },
    props.children
  )
}

Card.defaultProps = {
  as: "div",
}

export default Card
